import config from 'config';

export default function loadStripe() {
  if (document.getElementById('stripe-script')) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = 'stripe-script';
    script.src = 'https://js.stripe.com/v2/';
    script.async = 1;
    script.onload = () => {
      window.Stripe.setPublishableKey(config.stripeKey);
      resolve();
    };
    script.onerror = reject;

    document.body.appendChild(script);
  });
}




// WEBPACK FOOTER //
// ./app/utils/loadStripe.js